<template>
  <UButton variant="subtle" :color="getColorByRank">
    <slot />
  </UButton>
</template>
<script setup lang="ts">
interface Props {
  rank: string;
}

const props = withDefaults(defineProps<Props>(), {
  rank: "",
});

const getColorByRank = computed(() => {
  switch (props.rank) {
    case "entry":
      return "neutral";
    case "junior":
      return "info";
    case "middle":
      return "warning";
    case "senior":
      return "error";
    default:
      return "secondary";
  }
});
</script>
